export default "__VITE_ASSET__BIyysOXU__"